// @constants
const {
    GLOBAL_FOOTER_ELEMENT,
    RA_OK_COVER,
    RA_CUSTOM_PLAN_OBJ_VIEW,
    ZINDEX_DEFAULT_VAL,
    ZINDEX_DEF_OVERLAP_VAL,
} = require('../raConstants/index');
// Add the scrolling related helpers here

const getPageScrollHeight = () => document.body.scrollHeight;

const scrollHandler = (
    containerSection,
    ctaFooter,
    pageScrollHeight,
    footerScrollBuffer,
    raFooterSection,
    bufferInPixels = 5,
) => {
    const pageYOffset = window.pageYOffset;
    const containerElem =
        document.getElementsByClassName(containerSection) &&
        document.getElementsByClassName(containerSection)[0];
    const raOkCoverElement =
        document.getElementsByClassName(RA_OK_COVER) &&
        document.getElementsByClassName(RA_OK_COVER)[0];
    const coverElemOffset = raOkCoverElement.offsetTop;
    const genericFooterElement =
        document.getElementsByClassName(GLOBAL_FOOTER_ELEMENT) &&
        document.getElementsByClassName(GLOBAL_FOOTER_ELEMENT)[0];
    const containerRect = containerElem.getBoundingClientRect();
    const ctaButtonRect = raOkCoverElement
        .getElementsByTagName('button')[0]
        .getBoundingClientRect();
    const ctaButtonScrollOffset = ctaButtonRect.bottom + pageYOffset;
    const ctaFooterSection = ctaFooter;
    const footerScrollPos =
        pageScrollHeight - window.innerHeight - footerScrollBuffer;
    let styles = {};

    if (containerRect.bottom <= window.innerHeight) {
        raFooterSection.classList.remove(`${containerSection}__footer`);
        raFooterSection.classList.add(
            `${containerSection}__footer-buttons-position`,
        );
        if (containerSection == RA_CUSTOM_PLAN_OBJ_VIEW) {
            raFooterSection.classList.remove('ra-footer__content');
        }
    }

    if (containerRect.top > 0) {
        raFooterSection.classList.add(`${containerSection}__footer`);
        raFooterSection.classList.remove(
            `${containerSection}__footer-buttons-position`,
        );
    }

    if (
        pageYOffset + bufferInPixels >
            ctaButtonScrollOffset - coverElemOffset &&
        pageYOffset <= containerRect.height
    ) {
        if (pageYOffset >= footerScrollPos) {
            ctaFooterSection.classList.remove(
                `${containerSection}__container--blue-fixed`,
            );
            styles.zIndex = ZINDEX_DEFAULT_VAL;

            return;
        }
        ctaFooterSection.classList.add(
            `${containerSection}__container--blue-fixed`,
        );
        styles.zIndex = ZINDEX_DEF_OVERLAP_VAL;
    } else {
        ctaFooterSection.classList.remove(
            `${containerSection}__container--blue-fixed`,
        );
        styles.zIndex = ZINDEX_DEFAULT_VAL;
    }

    if (genericFooterElement) {
        genericFooterElement.style.zIndex = styles.zIndex;
    }
};

const resetElems = () => {
    const genericFooterElement =
        document.getElementsByClassName(GLOBAL_FOOTER_ELEMENT) &&
        document.getElementsByClassName(GLOBAL_FOOTER_ELEMENT)[0];
    if (genericFooterElement) {
        genericFooterElement.style.zIndex = ZINDEX_DEFAULT_VAL;
    }
};

export default {
    getPageScrollHeight,
    resetElems,
    scrollHandler,
};
